export default __webpack_public_path__ + "static/media/hazine-v2.7e211c6c.png";